const CompanyAdminProhibited: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          접근 권한이 없습니다
        </h2>
        <p className="text-gray-600 mx-10">페이지에 접근할 권한이 있는 지, 유효한 페이지인지 다시 확인해주세요.</p>
      </div>
    </div>
  );
};

export default CompanyAdminProhibited;
